import { AddCircle } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import ScheduleView from '../../components/Schedule';
import ScheduleBlockAddModal from '../../components/Schedule/ScheduleBlockAddModal';
import { getAllSchedules, addSchedule, addScheduleBlock, editScheduleBlock, deleteScheduleBlock, getEntitySchedules } from '../../services/MetadataService';


const ScheduleEditor = () => {
    const [schedules, setSchedules] = useState();
    const [entitySchedules, setEntitySchedules] = useState();
    const [openModal, setOpenModal] = useState(false);
    useEffect(() => {
        getAllSchedules().then(response => {
            setSchedules(response)
        });
        getEntitySchedules().then(response => {
            setEntitySchedules(response)
        });
    },[])

    const addNewSchedule = async(schedule) => {
        console.log("Adding schedule")
        console.log(schedule)
        return addSchedule(schedule).then(response => {
            console.log(response)
            return response;
        }).catch(error => {
            debugger;
            console.log(error);
            throw "Error adding schedule!"
        })
    }

    const addNewScheduleBlock = async (block) => {
        return addScheduleBlock(block).then(response => {
            console.log(response)
            
            //TODO: Just get this schedule and then replace it
            getAllSchedules().then(response => {
                setOpenModal(false)
                setSchedules(response)
                return true;
            });
            
        }).catch(err => {
            console.log(err)
        })
    }

    const editExistingScheduleBlock = async (block) => {
        return editScheduleBlock(block).then(response => {
            console.log(response)
            
            //TODO: Just get this schedule and then replace it
            getAllSchedules().then(response => {
                setOpenModal(false)
                setSchedules(response)
                return true;
            });
            
        }).catch(error => {
            console.log(error);
            throw ("There was an error editing the scheduling block")
        })
    }

    const deleteBlock = async (block) => {
        console.log("I am deleting a schedule block")
        console.log(block)
        return deleteScheduleBlock(block).then(response => {
            console.log(response)
            setOpenModal(false)

            //TODO: Just get this schedule and then replace it
            getAllSchedules().then(response => {
                setSchedules(response)
                return true;
            });
            
        })
    }

    console.log("In sschedule editor")

    return (
        <div className="layer3">
            <div className="location">
                <div className="schedule-add-mode">
                    <Tooltip title="Add a Schedule Block">
                        <IconButton
                                variant="contained"
                                color="primary"
                                aria-label={'Add schedule block'}
                                onClick={() => {
                                    setOpenModal(!openModal);
                                }}
                            >
                            <AddCircle style={{ fill: '#00b088', background: 'white', transform: "scale(1.2)" }} />
                        </IconButton>
                    </Tooltip>
                </div>
                <ScheduleView 
                    header="Schedule Overview" 
                    openModal={openModal} 
                    schedules={schedules} 
                    addSchedule={addNewSchedule}
                    addNewScheduleBlock={addNewScheduleBlock} 
                    editScheduleBlock={editExistingScheduleBlock} 
                    deleteBlock={deleteBlock} 
                    canEditSchedule={true}
                    entitySchedules={entitySchedules}
                    />
            </div>
        </div>
    )
}

export default ScheduleEditor;